module.exports = __webpack_public_path__ + "img/login-hero-desktop-1.84e17ced.jpg";